import { z } from "zod";
import { type FieldDescriptor } from "./types.js";

// A single labelled acknowledgement checkbox (docs/01-PRODUCT-SPEC.md §3.2). Unlike `terms`, this
// writes no consent record — use `terms` where evidence matters.
const configSchema = z.object({
  statement: z.string().max(1000).default(""),
});

export const decisionBoxField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "decision_box",
  label: "Acknowledgement",
  category: "legal",
  icon: "BadgeCheck",
  configSchema,
  valueSchema: (_config, isRequired) =>
    isRequired
      ? z.literal(true, { errorMap: () => ({ message: "This must be ticked to continue" }) })
      : z.boolean().optional().nullable(),
  defaultConfig: { statement: "" },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: {},
};
